import React from 'react';
import '../styles/ImageUrlModal.css';
import { Input } from '../components';
import { Warning } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';
import { isUnsupportedImageProvider } from '../utils/imageUtils';

function ImageUrlModal(props) {
    const imageUrl = props.imageUrl;
    const setImageUrl = props.setImageUrl;
    const error = props.error;

    const onChangeUrl = (e) => {
        setImageUrl(e.target.value);
    };

    const showUnsupportedWarning = imageUrl && imageUrl.trim() !== '' && isUnsupportedImageProvider(imageUrl);

    return (
        <div className="image-url-modal-body">
            <Input
                label={"Image URL"}
                labelType={"default"}
                info={false}
                value={imageUrl}
                onChange={onChangeUrl}
                placeholder={"https://drive.google.com/... or https://dropbox.com/..."}
                type="text"
                leftUnit={null}
                rightUnit={null}
                unitSwitch={false}
                leftUnitSelected={true}
                unitSwitchFunc={null}
                disabled={false}
                multiline={false}
                error={error || showUnsupportedWarning}
                onMouseEnter={null}
                onMouseLeave={null}
                reset={false}
                resetFunc={null}
                resetPosition={null}
                focusMultiline={false}
                prompt={false}
            />
            {showUnsupportedWarning ? (
                <div className="image-url-modal-warning">
                    <Warning fill={colour.orange03} />
                    <span className="label-regular colour-orange">
                        Google Photos links are <span className="label-bold underline">not</span> downloadable. Use Google Drive, Dropbox, or OneDrive instead.
                    </span>
                </div>
            ) : (
                <span className="body-regular colour-secondary image-url-modal-helper-text">
                    Paste a Google Drive, Dropbox, or OneDrive link. Google Photos links are <span className="body-semibold underline">not</span> supported.
                </span>
            )}
        </div>
    )
};

export default ImageUrlModal;
